import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Center,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import LoginForm from "./LoginForm";
import { colors } from "../../../theme/tokens/colors";
import SignUpForm from "./SignUpForm";

type IProps = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  defaultAuthState: "login" | "signup";
};

const AuthBanner = ({ open, onClose, defaultAuthState = "signup" }: IProps) => {
  const finalRef = React.useRef(null);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [authType, setAuthType] = useState(defaultAuthState);

  useEffect(() => {
    if (defaultAuthState) {
      setAuthType(defaultAuthState);
    }
  }, [defaultAuthState]);

  const form = (
    <Box>
      {authType === "signup" ? <SignUpForm /> : <LoginForm />}
      <Center mb={"1rem"}>
        {authType === "signup" ? (
          <Box display={"inline-flex"} gap={".5rem"}>
            <Text textAlign={"center"}>Existing user?</Text>{" "}
            <Text
              cursor={"pointer"}
              fontWeight={"bold"}
              textDecoration={"underline"}
              onClick={() => setAuthType("login")}
            >
              Log in
            </Text>
          </Box>
        ) : (
          <Box display={"inline-flex"} gap={".5rem"}>
            <Text textAlign={"center"}>New user?</Text>{" "}
            <Text
              cursor={"pointer"}
              fontWeight={"bold"}
              textDecoration={"underline"}
              onClick={() => setAuthType("signup")}
            >
              Sign up
            </Text>
          </Box>
        )}
      </Center>
    </Box>
  );

  return (
    <Modal
      isCentered={isMobile}
      finalFocusRef={finalRef}
      isOpen={open}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        bg={"blackAlpha.900"}
        borderRadius={"2rem"}
        mx={"1rem"}
        border={"1px solid"}
        borderColor={"neutral.900"}
        boxShadow={colors.shadow.white}
      >
        <ModalHeader></ModalHeader>
        <ModalCloseButton />
        <ModalBody>{form}</ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AuthBanner;
